import { cn } from '../lib/classNames.js';

type Props = {
  className?: string;
};

export const Skeleton = ({ className }: Props) => (
  <div aria-hidden className={cn('animate-pulse rounded-md bg-ink/5', className)} />
);
